import React from 'react'
import { toast, ToastOptions } from 'react-toastify'
import ToastBody from './ToastBody'
import {
  faExclamationCircle,
  faCheckCircle,
  faInfoCircle,
} from '@fortawesome/pro-solid-svg-icons'

export const ErrorToast = (text: any, options?: ToastOptions) => {
  return toast(<ToastBody icon={faExclamationCircle} text={text} />, {
    type: toast.TYPE.ERROR,
    ...options,
  })
}
export const SuccessToast = (text: any) => {
  return toast(<ToastBody icon={faCheckCircle} text={text} />, {
    type: toast.TYPE.SUCCESS,
  })
}
export const WarningToast = (text: any, options?: ToastOptions) => {
  return toast(<ToastBody icon={faInfoCircle} text={text} />, {
    type: toast.TYPE.WARNING,
    ...options,
  })
}
